


































import { Component, Vue, Prop } from 'vue-property-decorator';
import CertificateForm from '@/classes/CertificateForm';
import Certification from '@/classes/Certification';
import ReprintModal from '@/views/certificates/ReprintModal.vue';

@Component({
    components: {
        ReprintModal
    }
})
export default class DetailsCertificateForm extends Vue {
    @Prop({default: new CertificateForm({})}) public item!: CertificateForm;

    public getUserProfileName(id: number) {
        const user = this.$store.getters.getUserProfileById(id);
        return user ? user.getFullName() : '';
    }

    public getCertificationName(id: number) {
        const certification: Certification = this.$store.getters.getCertificationById(id);
        return (certification || {} as any).name || '';
    }

    public showReprintModal(): void {
        this.$nextTick(() => (this.$refs.reprintModal as ReprintModal).show());
    }
}
